import { createEventBus } from "./events.js";
import { createStore } from "./state.js";
import { createUiShell } from "./ui/shell.js";
import { createServices } from "./services/index.js";
import { loadTools } from "../tools/index.js";
import { createMap } from "./map.js"; // <-- IMPORTANT

export function createApp({ rootEl, mapEl, leftPanelEl, rightPanelEl, bottomPanelEl, topbarEl, hudEl, auth = null }) {
  console.log("[HydroTools] createApp() running. mapEl:", mapEl);

  const events = createEventBus();
  const store = createStore(events);
  const ui = createUiShell({ rootEl, leftPanelEl, rightPanelEl, bottomPanelEl, topbarEl, hudEl, mapEl, events, store });

  // Create Leaflet map instance (NO STUB)
  const map = { el: mapEl, instance: null };

  console.log("[HydroTools] calling createMap()...");
  map.instance = createMap({ mapEl, events });
  console.log("[HydroTools] map.instance =", map.instance);

  const services = createServices({ events, store, ui, map });

  const view = (() => {
    const host = mapEl?.parentElement || null;
    const topbarHost = topbarEl || null;
    const pane = document.createElement("div");
    pane.className = "potree-pane";
    pane.style.display = "none";
    pane.innerHTML = `
      <iframe class="potree-pane-frame" title="Potree Viewer" referrerpolicy="no-referrer"></iframe>
    `;
    const frame = pane.querySelector(".potree-pane-frame");
    let lastPotreeUrl = "";
    let currentMode = "map";
    if (host) host.appendChild(pane);

    const toggle = document.createElement("div");
    toggle.className = "view-toggle";
    toggle.innerHTML = `
      <button type="button" class="btn view-toggle-btn is-active" data-view-mode="map">Map</button>
      <button type="button" class="btn view-toggle-btn" data-view-mode="potree">Potree</button>
    `;
    if (topbarHost) topbarHost.appendChild(toggle);
    const mapBtn = toggle.querySelector('[data-view-mode="map"]');
    const potreeBtn = toggle.querySelector('[data-view-mode="potree"]');

    function updateToggleUi() {
      const isMap = currentMode === "map";
      mapBtn?.classList.toggle("is-active", isMap);
      potreeBtn?.classList.toggle("is-active", !isMap);
      potreeBtn.disabled = !lastPotreeUrl;
      potreeBtn.title = lastPotreeUrl ? "Show Potree viewer" : "Open a Potree viewer first";
    }

    function showMap() {
      if (!host) return;
      currentMode = "map";
      host.dataset.mainView = "map";
      mapEl.style.display = "";
      if (hudEl) hudEl.style.display = "";
      pane.style.display = "none";
      updateToggleUi();
      try { map.instance?.invalidateSize?.(false); } catch {}
      setTimeout(() => {
        try { map.instance?.invalidateSize?.(false); } catch {}
      }, 120);
    }

    function showPotree(url) {
      if (!host) return;
      const nextUrl = String(url || lastPotreeUrl || "").trim();
      if (!nextUrl) return;
      lastPotreeUrl = nextUrl;
      currentMode = "potree";
      host.dataset.mainView = "potree";
      if (frame && frame.getAttribute("src") !== nextUrl) frame.setAttribute("src", nextUrl);
      mapEl.style.display = "none";
      if (hudEl) hudEl.style.display = "none";
      pane.style.display = "";
      updateToggleUi();
    }

    function getPotreeWindow() {
      try { return frame?.contentWindow || null; } catch { return null; }
    }

    mapBtn?.addEventListener("click", showMap);
    potreeBtn?.addEventListener("click", () => showPotree(lastPotreeUrl));
    updateToggleUi();
    return { showMap, showPotree, getPotreeWindow };
  })();

  const appContext = {
    events,
    store,
    ui,
    map,
    view,
    services,
    auth,
    log: async (action, details = {}) => {
      try {
        await fetch("/api/activity/log", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ action, details, userEmail: auth?.email ?? null, userSub: auth?.sub ?? null }),
        });
      } catch {}
    },
  };

  const tools = loadTools(appContext);

  const runtime = Object.freeze({
    ...appContext,
    tools,
  });

  ui.bindRuntime?.(runtime);
  window.__hydrotools = runtime;
  return runtime;
}
